// lib/GTM.jsx
"use client";
import { useEffect } from "react";

export default function GTMScript() {
  useEffect(() => {
    // Skip in development — HMR causes DOM conflicts
    if (process.env.NEXT_PUBLIC_ENV === "development") return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    if (document.querySelector(`script[src*="GTM-MGJT7QLJ"]`)) return;

    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MGJT7QLJ";
    script.async = true;

    try {
      document.head.appendChild(script);
    } catch (e) {
      console.warn("GTM injection skipped:", e.message);
    }
  }, []);

  return null; // noscript is already in layout.jsx <body>
}
